<template>
  <div class="dropdown" :class="{ 'inline-mode': inline }">
    <button class="btn btn-outline-primary dropdown-toggle m-0" type="button" id="dropdownMenuButton" 
      :data-bs-toggle="autoExpand ? '' : 'dropdown'"
      :aria-expanded="autoExpand ? 'true' : 'false'"
      @click="autoExpand ? toggleExpanded() : null">
      {{ selectedItem ? `${selectedItem[displayKey]}` : placeholder }}
      <i class="bi" :class="isExpanded ? 'bi-chevron-up' : 'bi-chevron-down'" v-if="inline && !autoExpand"></i>
    </button>
    
    <ul class="dropdown-menu" :class="{ 'show': autoExpand && isExpanded, 'inline-dropdown': inline }" aria-labelledby="dropdownMenuButton">
      <li>
        <input type="text" class="form-control" v-model="searchQuery" :placeholder="searchPlaceholder"
          @input="filterOptions">
      </li>

      <div class="options-list">
        <li v-for="item in filteredItems" :key="item[valueKey]">
          <a class="dropdown-item" href="#" @click="selectItem(item)" :class="item.disabled ? 'disabled' : null">
            {{ item[displayKey] }}
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Selecione uma opção'
    },
    searchPlaceholder: {
      type: String,
      default: 'Pesquisar...'
    },
    displayKey: {
      type: String,
      default: 'option'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    initialSelectedItem: {
      type: Object,
      default: null
    },
    // Modo inline - opções aparecem abaixo em vez de flutuar
    inline: {
      type: Boolean,
      default: false
    },
    // Auto expandir - já aparece expandido
    autoExpand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedItem: null,
      isExpanded: false
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item =>
        item[this.displayKey]?.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
      this.searchQuery = '';
      
      if (!this.autoExpand) {
        this.isExpanded = false;
      }
      
      this.$emit('update:modelValue', item[this.valueKey]);
      this.$emit('update:selectedItem', item[this.valueKey]);
      this.$emit('item-selected', item[this.valueKey]);
    },
    filterOptions() {
      // Filtro já é feito pelo computed filteredItems
    },
    toggleExpanded() {
      if (this.inline || this.autoExpand) {
        this.isExpanded = !this.isExpanded;
      }
    }
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedItem) {
          this.selectedItem = newVal.find(value => {
            return value[this.valueKey] == this.initialSelectedItem})
        }
      }
    },
    modelValue(newVal) {
      this.selectedItem = this.items.find(value => value[this.valueKey] === newVal) || null;
    },
    initialSelectedItem: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        this.selectedItem = this.items.find(value => {
          return value[this.valueKey] == newVal})
      }
    },
  },
  mounted() {
    // Auto expandir quando o componente é montado
    if (this.autoExpand) {
      this.isExpanded = true;
    }
  }
}
</script>

<style scoped>
/* Estilos base (dropdown original) */
.dropdown-toggle {
  width: 250px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-menu {
  min-width: 300px;
  overflow-y: auto;
}

.options-list {
  max-height: 350px;
  overflow: auto;
}

.form-control {
  width: 100%;
  margin-bottom: 10px;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #007bff;
  color: white;
}

/* Força exibição quando autoExpand está ativo */
.dropdown-menu.show {
  display: block;
}

/* Modificações para modo inline */
.dropdown.inline-mode {
  position: relative;
}

.dropdown.inline-mode .dropdown-menu {
  position: static !important;
  float: none !important;
  display: block;
  margin-top: 2px;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  transform: none !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
}

/* Esconde o dropdown inline por padrão (só mostra quando expanded ou autoExpand) */
.dropdown.inline-mode .dropdown-menu:not(.show) {
  display: none;
}

/* Mostra quando está expandido no modo inline */
.dropdown.inline-mode .dropdown-menu.inline-dropdown {
  display: block;
}
</style>
